import { Container } from "react-bootstrap";

export const About = () => {
    return (
        <section className="Aboutme" id="about">
            <Container>
                <h2>Abou<span className="underline">t M</span>e</h2>
                <div className="d-flex flex-column align-items-center">
                    <div class="wrapper">
                        <div className="box">
                            <p >I'm May Pyone, an aspiring full-stack developer with a strong passion for learning and growing in the field of software development. I enjoy collaborating with developers from diverse backgrounds and have gained valuable experience working on group projects that combine technical and soft skills. As I continue to build my expertise, I’m excited to contribute to innovative projects and learn from others in the tech community.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="skill">
                    <div className="language"><h3>Technical Skills</h3>
                        <ul>
                            <li>JavaScript</li>
                            <li>JavaScript</li>
                            <li>TypeScript</li>
                            <li>Kotlin</li>
                            <li>JavaSE</li>
                            <li>Ruby</li>
                            <li>PostgreSQL </li>
                            <li>Docker</li>
                            <li>Git/GitHub</li>
                        </ul>
                    </div>
                    <div className="frameworks">
                        <h3>Frameworks & Libraries</h3>
                        <ul>
                            <li>React.js</li>
                            <li>Redux</li>
                            <li>Zustand</li>
                            <li>Ruby on Rails</li>
                            <li>Quarkus</li>
                            <li>Bootstrap</li>
                            <li>Tailwind CSS</li>
                            <li>PlayWright</li>
                            <li>RSpec</li>
                            <li>Capybara</li>
                            <li>Jest</li>
                          
                        </ul></div>
                    <div className="skills">
                        <h3>Soft Skills</h3>
                        <ul>
                              <li>Effective Communication</li>
                              <li>Teamwork & Collaboration</li>
                              <li>Problem-Solving & Critical Thinking</li>
                              <li>Time Management</li>
                              <li>Adaptability & Flexibility</li>
                              <li>Attention to Detail</li>
                              <li>Self-Motivation & Fast Learning</li>
                        </ul>
                    </div>
                </div>
            </Container>




        </section>
    )
}
